export default __webpack_public_path__ + "static/plxogimage-8d32cd4335e1d4244e4434411347d268.jpg";